import { createSlice } from "@reduxjs/toolkit";

const authErrorSlice = createSlice({
  name: "authError",
  initialState: {
    showModal: false,
    message: "",
  },
  reducers: {
    showAuthErrorModal: (state, action) => {
      state.showModal = true;
      state.message = action.payload || "";
    },
    hideAuthErrorModal: (state) => {
      state.showModal = false;
      state.message = "";
    },
  },
});

export const { showAuthErrorModal, hideAuthErrorModal } =
  authErrorSlice.actions;

export default authErrorSlice.reducer;
